import { Q as spread_props, R as bind_props, P as pop, N as push, a3 as slot } from "../../../chunks/index.js";
import { C as ClassAdder } from "../../../chunks/ClassAdder.js";
import "clsx";
function AppContent($$payload, $$props) {
  push();
  let { children, $$slots, $$events, ...restProps } = $$props;
  let element;
  function getElement() {
    return element.getElement();
  }
  ClassAdder($$payload, spread_props([
    {
      _smuiClass: "mdc-drawer-app-content",
      tag: "div"
    },
    restProps,
    {
      children: ($$payload2) => {
        children?.($$payload2);
        $$payload2.out += `<!---->`;
      },
      $$slots: { default: true }
    }
  ]));
  bind_props($$props, { getElement });
  pop();
}
function _layout($$payload, $$props) {
  AppContent($$payload, {
    class: "w-full h-full",
    children: ($$payload2) => {
      $$payload2.out += `<!---->`;
      slot($$payload2, $$props, "default", {});
      $$payload2.out += `<!---->`;
    },
    $$slots: { default: true }
  });
}
export {
  _layout as default
};
